import { createContext } from 'react'

import { getCookie } from 'cookies-next'

import toString from 'lodash/toString'

export const Context = createContext<string | undefined>(undefined)
Context.displayName = 'TokenContext'

export const Provider = Context.Provider
export const Consumer = Context.Consumer

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const TokenContext = ({ children }: Props) => {
  const value = toString(getCookie('access_token')) || undefined

  return <Provider value={value}>{children}</Provider>
}

export default TokenContext
